/**
 * デジタルサイネージ用モジュール
 *
 * @module app/signage/display/SignageDamageListPage
 */
define(['module',
        'dojo',
        'dojo/_base/array',
        'dojo/_base/declare',
        'dojo/_base/lang',
        'dojo/dom-class',
        'dojo/dom-construct',
        'dojo/dom-style',
        'dojo/text!./templates/SignageDamageListPage.html',
        'idis/service/Requester',
        'idis/view/Loader',
        '../_SignageBase',
        //'../../config',
        // 以下、変数で受けないモジュール
        'dijit/Dialog',
        'dijit/form/Form',
        'dijit/layout/BorderContainer',
        'dijit/layout/ContentPane',
        'idis/view/form/AclButton',
], function(module, dojo, array, declare, lang, domClass, domConstruct, domStyle, template, Requester, Loader, _SignageBase) {

        // 前回表示データ
        // セッションストレージ等に保持するほうが良いか？
        var prevItemStore = {};

        /**
         *
         * @class SignageDamageListPage
         * @extends module:idis/view/page/_PageBase~_PageBase
         */
        return declare(module.id.replace(/\//g, '.'), _SignageBase,
        /** @lends module:app/signage/display/SignageDamageListPage~SignageDamageListPage# */
        {
            // テンプレート文字列
            templateString: template,

            _timer: null,

            // 表示ページ
            _page: 0,

            // ページあたり表示件数
            PAGE_LIST_SIZE: 6,

            // ページ切替間隔時間（秒）
            SIGNAGE_UPDATE_INTERVAL: 10,

            // 値を表示する項目のリスト
            target: [
                {'item':'totalDamageNum', 'area':'totalDamageNumArea', 'area2':'totalDamageNumArea2'},
                {'item':'sedDamageNum', 'area':'sedDamageNumArea', 'area2':'sedDamageNumArea2'},
                {'item':'houseDamageNum', 'area':'houseDamageNumArea', 'area2':'houseDamageNumArea2'},
                {'item':'riverDamageNum', 'area':'riverDamageNumArea', 'area2':'riverDamageNumArea2'},
                {'item':'deadNum', 'area':'deadNumArea', 'area2':'deadNumArea2', 'area3':'deadNumArea3'},
                {'item':'unknownNum', 'area':'unknownNumArea', 'area2':'unknownNumArea2', 'area3':'unknownNumArea3'},
                {'item':'seriousNum', 'area':'seriousNumArea', 'area2':'seriousNumArea2', 'area3':'seriousNumArea3'},
                {'item':'mildNum', 'area':'mildNumArea', 'area2':'mildNumArea2', 'area3':'mildNumArea3'},
                {'item':'cutOffComNum', 'area':'cutOffComNumArea', 'area2':'cutOffComNumArea2'},
            ],

            // ルート要素に付与されるCSS
            baseClass: 'idis-Page idis-Page--signage',

            constructor: function() {
                this.inherited(arguments);
            },

            buildRendering: function() {
                this.inherited(arguments);
            },

            startup: function() {
                this.inherited(arguments);
                this.initPage();
            },

            destroy: function() {
                this.inherited(arguments);
                clearTimeout(this._timer);
            },

            /**
             * 画面表示
             */
            initPage: function() {
                this.setDamgeListInfo();
            },

            /**
             * 個別被害情報一覧を設定します
             */
            setDamgeListInfo: function() {
                var promise = Requester.get('/data/signage/' + this._screenId +'.json', {
                    headers: {'Content-Type': 'application/json; charset=utf-8'},
                    handleAs: 'json',
                    preventCache : true
                }).then(lang.hitch(this, function (item) {
                    // 体制概況情報を設定
                    var damageListInfo = item.items.filter(function(element) {
                        return element.admNum === null;
                    });
                    this.setDamageListInfo(this, damageListInfo);
                    var damageDetailList = item.items.filter(function(element) {
                        return element.admNum !== null;
                    });
                    this.setDamageDetailList(this, damageDetailList);
                    // 前回データを更新
                    prevItemStore[this._screenId] = item;

                }), function (error) {
                    if (error.response.status === 404) {
                        var damageListInfo = {};
                        this.setDamageListInfo(this, damageListInfo);
                        var damageDetailList = [];
                        this.setDamageDetailList(this, damageDetailList);
                    } else {
                        this.chain.info('情報の取得に失敗しました。', 'エラー');
                    }
                });
                //ローダーの表示
                Loader.wait(promise);
            },

            /**
             * 集計値を設定します
             */
            setDamageListInfo: function(self, item) {
                // 項目に取得した値を設定
                array.forEach(this.target, function(target){
                    self[target.item].innerHTML = item[0][target.item];
                });
                // 更新状態を設定
                this.setDamageListInfoUpdate(self, item);
            },

            /**
             * 画面上部エリアの更新状態を設定します
             */
            setDamageListInfoUpdate: function(self, item) {
                var updateFlg = false;
                // 画面右上部に表示する項目
                const list = ['deadNum', 'unknownNum', 'seriousNum', 'mildNum'];
                // 前回データがある場合のみ処理
                // 前回データがない場合（≒初回表示）は処理しない
                var prevItem = prevItemStore[this._screenId];
                if (!prevItem || !item) {
                    return;
                }
                var totalNum = prevItem.items[0];
                if (totalNum) {
                    array.forEach(this.target, function(target){
                        // 更新された項目にstyleを設定
                        if (totalNum[target.item] !== item[0][target.item]) {
                            domClass.add(self[target.area], 'update-column');
                            domClass.add(self[target.area2], 'update-column');
                            if (list.includes(target.item)) {
                                domClass.add(self[target.area3], 'update-column');
                            }
                            updateFlg = true;
                        } else {
                            domClass.remove(self[target.area], 'update-column');
                            domClass.remove(self[target.area2], 'update-column');
                            if (list.includes(target.item)) {
                                domClass.remove(self[target.area3], 'update-column');
                            }
                        }
                    });
                }
                // 更新された項目がある場合、通知音を鳴らす
                if (updateFlg) {
                    this.playAudio();
                }
            },

            /**
             * 個別被害情報一覧を設定します
             */
            setDamageDetailList: function(self, data) {
                // 表示をクリア
                var damageListTBody = dojo.byId('damageListTBody');
                domConstruct.empty(damageListTBody);

                // 集計エリアのタイトルを設定
                var dataLength = data.length;
                var aggrigateAreaTitleStr = '';
                aggrigateAreaTitleStr = '県内合計';
                if (dataLength > 0 && data.every(item => item.municipalityName === data[0].municipalityName && item.municipalityName !== '広島県')) {
                    aggrigateAreaTitleStr = '市内合計（' + data[0].municipalityName + '）';
                }
                self.aggrigateAreaTitle.innerHTML =  aggrigateAreaTitleStr;

                // 表示対象ページの抽出
                var firstIndex = this.PAGE_LIST_SIZE * this._page;
                var lastIndex = this.PAGE_LIST_SIZE * (this._page + 1) - 1;
                var displayData = data.filter((element, index) =>
                    index >= firstIndex && index <= lastIndex
                );

                // 画面上のページ数表示
                self.currentPage.innerHTML = this._page + 1;
                self.totalPage.innerHTML = Math.ceil(data.length / this.PAGE_LIST_SIZE);

                var prevItem = prevItemStore[this._screenId];
                var damageDetailList = [];
                if (prevItem) {
                    damageDetailList = prevItem.items.filter(function(element) {
                        return element.admNum !== null;
                    });
                }
                var updateFlg = false;

                array.forEach(displayData, function(item){
                    // 避難所の前回値
                    var damagePrevItem = null;
                    if (damageDetailList && damageDetailList.length > 0) {
                        damagePrevItem = damageDetailList.filter((element) =>
                            element.admNum === item.admNum
                        )[0];
                        // 新規のデータが追加された場合は前回値を0として設定
                        if (damagePrevItem === undefined) {
                            damagePrevItem = {"crtTimestamp": null, "damageAddress": null, "content": null, "damageType": null, 
                            "humanDamageFlg": null, "urgencyType": null, "hldStatus": null, "reportAuthorName": null};
                        }
                    }

                    var className = '';
                    var tr = domConstruct.create('tr');
                    // 管理番号
                    domConstruct.place(domConstruct.create('td', {
                        innerHTML: item.admNum, class: 'align-middle text-center fw-bold first-col'}), tr);

                    // 発生日時
                    className = damagePrevItem && (damagePrevItem.crtTimestamp !== item.crtTimestamp) ? 'update-column' : '';
                    if (className)  { updateFlg = true; };
                    className = className + ' align-middle text-center';
                    domConstruct.place(domConstruct.create('td', {
                        innerHTML: '<span class="fs-6">' + item.crtTimestamp + '</span>', class: className}), tr);

                    // 住所
                    className = damagePrevItem && (damagePrevItem.damageAddress !== item.damageAddress)  ? 'update-column' : '';
                    if (className)  { updateFlg = true; };
                    className = className + ' align-middle text-center';
                    domConstruct.place(domConstruct.create('td', {
                        innerHTML: '<span class="fs-6">' + item.damageAddress + '</span>', class: className}), tr);
                    
                    // 内容
                    className = '';
                    className = damagePrevItem && (damagePrevItem.content !== item.content) ? 'update-column' : '';
                    if (className)  { updateFlg = true; };
                    className = className + ' align-middle';
                    const maxlength = 22;
                    var content = '';
                    if (item.content.length > maxlength) {
                        content =  item.content.substr(0, maxlength) + '…';
                    } else {
                        content = item.content;
                    }
                    domConstruct.place(domConstruct.create('td', {
                        innerHTML: '<span class="fs-6">' + content + '</span>', class: className}), tr);

                    // 被害種別
                    className = damagePrevItem && (damagePrevItem.damageType !== item.damageType) ? 'update-column' : '';
                    if (className)  { updateFlg = true; };
                    className = className + ' align-middle text-center';
                    domConstruct.place(domConstruct.create('td', {
                        innerHTML: '<span class="fs-6">' + item.damageType + '</span>', class: className}), tr);

                    // 人的被害
                    className = damagePrevItem && (damagePrevItem.humanDamageFlg !== item.humanDamageFlg) ? 'update-column' : '';
                    if (className)  { updateFlg = true; };
                    var humanDamage = '';
                    var addStyle = '';
                    switch(item.humanDamageFlg) {
                        case '0':
                            humanDamage = 'あり';
                            addStyle = 'damage-positive fw-bold';
                        break;
                        case '1':
                            humanDamage = 'なし';
                        break;
                    }
                    className = className + ' align-middle text-center ' + addStyle;
                    domConstruct.place(domConstruct.create('td', {
                        innerHTML: '<span class="fs-6">' + humanDamage + '</span>', class: className}), tr);

                    // 緊急度
                    className = damagePrevItem && (damagePrevItem.urgencyType !== item.urgencyType) ? 'update-column' : '';
                    if (className)  { updateFlg = true; };
                    var urgencyType = '';
                    var addStyle = '';
                    switch(item.urgencyType) {
                        case '0':
                            urgencyType = '-';
                        break;
                        case '1':
                            urgencyType = '低';
                        break;
                        case '2':
                            urgencyType = '中';
                            addStyle = 'midium-urgency';
                        break;
                        case '3':
                            urgencyType = '高';
                            addStyle = 'high-urgency';
                        break;
                    }
                    className = className + ' align-middle text-center ' + addStyle;
                    domConstruct.place(domConstruct.create('td', {
                        innerHTML: '<span class="fs-6">' + urgencyType + '</span>', class: className}), tr);

                    // 対応状況
                    className = damagePrevItem && (damagePrevItem.hldStatus !== item.hldStatus) ? 'update-column' : '';
                    if (className)  { updateFlg = true; };
                    className = className + ' align-middle text-center';
                    var hldStatus = '';
                    switch(item.hldStatus) {
                        case '1':
                            hldStatus = '未対応';
                        break;
                        case '2':
                            hldStatus = '対応中';
                        break;
                        case '3':
                            hldStatus = '対応済';
                        break;
                        case '9':
                            hldStatus = '確認中';
                        break;
                    }
                    domConstruct.place(domConstruct.create('td', {
                        innerHTML: '<span class="fs-6">' + hldStatus + '</span>', class: className}), tr);

                    // 報告者
                    className = damagePrevItem && (damagePrevItem.reportAuthorName !== item.reportAuthorName) ? 'update-column' : '';
                    if (className)  { updateFlg = true; };
                    className = className + ' align-middle text-center';
                    domConstruct.place(domConstruct.create('td', {
                        innerHTML: '<span class="fs-8">' + item.deptName + '</span>' +
                        '<br>' + '<span class="fs-6">' + item.reportAuthorName + '</span>', class: className}), tr);

                    domConstruct.place(tr, damageListTBody);
                });

                // 次回表示ページ
                if (lastIndex >= data.length - 1) {
                    // 先頭ページ
                    this._page = 0;
                } else {
                    // 次ページ
                    this._page += 1;
                }  

                // 更新された項目がある場合、通知音を鳴らす
                if (updateFlg) {
                    this.playAudio();
                }

                // 定期更新処理
                this._timer = setTimeout(lang.hitch(this, function() {
                    self.setDamageDetailList(self, data);
                }), this.SIGNAGE_UPDATE_INTERVAL * 1000);
            }
        });
    });
